import { createFileRoute } from "@tanstack/react-router";
import { CategoryListing } from "@/components/venues/CategoryListing";

export const Route = createFileRoute("/_categories/event-centres")({
  head: () => ({
    meta: [
      { title: "Premium Event Centres & Halls in Oyo State — OyoBooking" },
      {
        name: "description",
        content:
          "Book standard event centres, wedding halls, conference halls and grand ballrooms across Oyo State, Nigeria.",
      },
    ],
    links: [{ rel: "canonical", href: "https://oyobooking.ng/event-centres" }],
  }),
  component: () => <CategoryListing category="event-centre" />,
});
